module.exports = __webpack_public_path__ + "static/media/kitchen.26900736.jpg";